function isTimedActive(entry, now) {
  if (!entry || !entry.until) return false;
  const until = new Date(entry.until);
  return !Number.isNaN(until.getTime()) && now.getTime() < until.getTime();
}

function formatDndUntil(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

function exceptionLine(entry) {
  const parts = [];
  if (entry.exceptEmergencies !== false) parts.push('emergencies');
  if (entry.exceptStaff !== false) parts.push('staff');
  if (parts.length === 2) return 'Except emergencies and staff';
  if (parts.length === 1) return `Except ${parts[0]}`;
  return '';
}

function dndStatusLines(entry, now) {
  const lines = [];
  if (entry.alwaysOn) lines.push('Always on');
  if (isTimedActive(entry, now)) {
    const label = formatDndUntil(entry.until);
    if (label) lines.push(`Until ${label}`);
  }
  const exceptions = exceptionLine(entry);
  if (exceptions) lines.push(exceptions);
  const keywords = String(entry.keywords || '').trim();
  if (keywords) lines.push(`Keywords: ${keywords}`);
  return lines;
}

function flagOn(value) {
  return value !== false && value !== 0;
}

function deviceRows(local) {
  return (Array.isArray(local.devices) ? local.devices : []).filter(
    (device) => device && device.deviceId,
  );
}

function dndStatusEntries(serverRows, local = {}) {
  const now = local.now instanceof Date ? local.now : new Date();
  const devices = deviceRows(local);
  const rows = (serverRows || [])
    .filter((row) => isTimedActive(row, now))
    .map((row) => ({
      ...row,
      alwaysOn: false,
      deviceId: '',
      deviceLabel: '',
    }));
  for (const device of devices) {
    if (!device.ownsTimed) continue;
    const timed = rows.find((row) => Number(row.userId) === Number(device.userId));
    if (!timed || timed.deviceId) continue;
    timed.deviceId = String(device.deviceId);
    timed.deviceLabel = String(device.label || '');
  }
  for (const device of devices) {
    if (!device.alwaysOn) continue;
    const sameDevice = rows.find(
      (row) =>
        Number(row.userId) === Number(device.userId) &&
        row.deviceId === String(device.deviceId),
    );
    if (sameDevice) {
      sameDevice.alwaysOn = true;
      if (!sameDevice.deviceLabel) sameDevice.deviceLabel = String(device.label || '');
      continue;
    }
    rows.push({
      userId: device.userId,
      name: device.name,
      deviceId: String(device.deviceId),
      deviceLabel: String(device.label || ''),
      until: null,
      exceptEmergencies: flagOn(device.exceptEmergencies),
      exceptStaff: flagOn(device.exceptStaff),
      keywords: device.keywords || '',
      alwaysOn: true,
    });
  }
  if (local.alwaysOn && !local.deviceId) {
    const id = Number(local.userId);
    const mine = rows.find((row) => Number(row.userId) === id);
    if (mine) {
      mine.alwaysOn = true;
    } else {
      rows.unshift({
        userId: id,
        name: local.name || 'You',
        until: null,
        exceptEmergencies: local.exceptEmergencies !== false,
        exceptStaff: local.exceptStaff !== false,
        keywords: local.keywords || '',
        alwaysOn: true,
      });
    }
  } else if (local.alwaysOn && local.deviceId) {
    const id = Number(local.userId);
    const deviceId = String(local.deviceId);
    const mine = rows.find(
      (row) => Number(row.userId) === id && row.deviceId === deviceId,
    );
    if (mine) {
      mine.alwaysOn = true;
      if (!mine.deviceLabel) mine.deviceLabel = String(local.deviceLabel || '');
    } else {
      rows.unshift({
        userId: id,
        name: local.name || 'You',
        deviceId,
        deviceLabel: String(local.deviceLabel || ''),
        until: null,
        exceptEmergencies: local.exceptEmergencies !== false,
        exceptStaff: local.exceptStaff !== false,
        keywords: local.keywords || '',
        alwaysOn: true,
      });
    }
  }
  return rows
    .map((row) => ({
      key: `${row.userId}:${row.deviceId || 'account'}`,
      userId: row.userId,
      name: row.deviceLabel ? `${row.name} · ${row.deviceLabel}` : row.name,
      lines: dndStatusLines(row, now),
    }))
    .sort((a, b) => a.name.localeCompare(b.name) || a.key.localeCompare(b.key));
}

function dndStatusPayload(data) {
  if (Array.isArray(data)) return { rows: data, devices: [] };
  return {
    rows: (data && data.rows) || [],
    devices: (data && data.devices) || [],
  };
}

module.exports = {
  dndStatusEntries,
  dndStatusPayload,
};
